export default __webpack_public_path__ + "static/tailgating-b3090c72075d59641f6e083d14ff5742.mp4";